import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=37353850&"
import script from "./ChatModal.vue?vue&type=script&lang=js&"
export * from "./ChatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports